import { motion } from "framer-motion";

const stats = [
  { value: "1.6+", label: "Years at Aiwoox" },
  { value: "3+", label: "Production Projects" },
  { value: "MCA", label: "Nitte Meenakshi IT" },
  { value: "Open", label: "To Opportunities" },
];

const highlights = [
  { text: "AWS EC2, S3, RDS, IAM, Cognito, VPC" },
  { text: "Docker, Kubernetes, NGINX, VPS" },
  { text: "CI/CD — GitHub Actions, Jenkins" },
  { text: "Angular, Next.js, Node.js, TypeScript" },
  { text: "SSL, DNS, Security Hardening" },
  { text: "Monitoring, Logs, Performance Tuning" },
];

export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-sky-400 font-semibold uppercase tracking-widest text-sm mb-2">Who I Am</p>
          <h2 className="text-4xl md:text-5xl font-black text-white">About Me</h2>
          <div className="w-16 h-1 bg-sky-500 mx-auto mt-4 rounded-full" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-10 items-start">
          {/* Left */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="space-y-5"
          >
            <h3 className="text-xl md:text-2xl font-bold text-white">
              Cloud &amp; DevOps Engineer at{" "}
              <span className="gradient-text">Aiwoox</span>
            </h3>
            <p className="text-slate-400 leading-relaxed text-sm">
              I'm <span className="text-white font-semibold">Veerabhadraswamy C T</span>, a DevOps and Full-Stack
              Engineer with hands-on experience deploying, automating, and managing production applications using
              AWS services — EC2, S3, IAM, VPC — along with Docker, NGINX, SSL, and VPS infrastructure.
            </p>
            <p className="text-slate-400 leading-relaxed text-sm">
              Strong expertise in <span className="text-sky-400 font-semibold">CI/CD automation</span> using
              GitHub Actions, Jenkins, Docker, and Kubernetes. Skilled in cloud-ready application development
              with Angular, TypeScript, Supabase, and API integrations.
            </p>
            <p className="text-slate-400 leading-relaxed text-sm">
              Experienced in infrastructure security, system monitoring, DNS and domain management, performance
              optimization, and maintaining <span className="text-sky-400 font-semibold">high-availability production environments</span>.
            </p>

            {/* Education */}
            <div className="bg-[#0d1526] border border-sky-500/20 rounded-2xl p-5">
              <p className="text-sky-400 text-xs font-semibold uppercase tracking-wider mb-3">Education</p>
              <p className="text-white font-bold">Master of Computer Applications (MCA)</p>
              <p className="text-slate-400 text-sm">Nitte Meenakshi Institute of Technology, Bengaluru</p>
              <p className="text-slate-500 text-xs mt-1">Graduated: July 2024</p>
            </div>
          </motion.div>

          {/* Right */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="space-y-5"
          >
            {/* Stats */}
            <div className="grid grid-cols-2 gap-3">
              {stats.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  className="bg-[#0d1526] border border-sky-500/20 rounded-xl p-4 text-center card-hover"
                >
                  <p className="gradient-text text-2xl font-black">{s.value}</p>
                  <p className="text-slate-400 text-xs mt-1">{s.label}</p>
                </motion.div>
              ))}
            </div>

            {/* Highlights */}
            <p className="text-slate-300 font-semibold text-sm uppercase tracking-wider">Core Expertise</p>
            <div className="grid grid-cols-1 gap-2">
              {highlights.map((h, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  className="flex items-center gap-3 bg-[#0d1526] border border-sky-500/10 rounded-xl px-4 py-3"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-sky-400 shrink-0" />
                  <span className="text-slate-300 text-sm">{h.text}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
